import React, { createContext, useContext } from "react";

export interface IUser {
  email: string;
  role?: string;
  // ...add other fields as needed
}

export const UserContext = createContext<IUser | null>(null);

export const useUser = () => useContext(UserContext);